import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';

export default function KendoSelectFilter(data: any, defaultItem: any) {
  return class extends React.Component<any> {
    render() {
      return (
        <div className="k-filtercell">
          <DropDownList
            data={data}
            onChange={this.onChange}
            value={this.props.value || defaultItem}
            defaultItem={defaultItem}
            style={{width: '200px'}}
          />
        </div>
      );
    }

    hasValue = (value: any) => Boolean(value);
    onChange = (event: any) => {
      const hasValue = this.hasValue(event.target.value);
      this.props.firstFilterProps.onChange({
        value: hasValue ? event.target.value : '',
        operator: hasValue ? 'eq' : '',
        syntheticEvent: event.syntheticEvent
      });
    }

    onClearButtonClick = (event: any) => {
      event.preventDefault();
      this.props.onChange({
        value: '',
        operator: '',
        syntheticEvent: event
      });
    }
  };
}
